import { ContentChildren, Directive, forwardRef, QueryList, ViewChildren } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive()
/**
 * For proper validation all components in form must have ComponentsContainer as base class.
 * Each component should provide NG_VALUE_ACCESSOR or have
 * { provide: FiComponentsContainer, useExisting: <target component> } in providers
 */
export abstract class FiComponentsContainer {
    @ViewChildren(NgModel, {}) inputs: QueryList<NgModel>;
    @ContentChildren(NgModel, { descendants: true }) contentInputs: QueryList<NgModel>;

    @ViewChildren(forwardRef(() => FiComponentsContainer), {}) containers: QueryList<FiComponentsContainer>;
    @ContentChildren(forwardRef(() => FiComponentsContainer), { descendants: true })
    contentContainers: QueryList<FiComponentsContainer>;

    /**
     * method for gathering all ngModels recursively for validation purposes etc
     */
    getDescendantNgModels(args: { descendants: boolean } = { descendants: true }) {
        const allNgModels: NgModel[] = (this.inputs ? this.inputs.toArray() : []).concat(
            this.contentInputs ? this.contentInputs.toArray() : [],
        );

        if (args?.descendants) {
            // gather child containers from @ViewChildren
            const childContainers = this.getChildContainers();

            // merge with containers from ngModels
            allNgModels.forEach((ngModel) => {
                if (
                    ngModel.valueAccessor instanceof FiComponentsContainer &&
                    childContainers.indexOf(ngModel.valueAccessor) === -1
                ) {
                    childContainers.push(ngModel.valueAccessor);
                }
            });

            childContainers.forEach((childContainer) => {
                allNgModels.push(...childContainer.getDescendantNgModels(args));
            });
        }

        return allNgModels;
    }

    protected getChildContainers(): FiComponentsContainer[] {
        return (this.containers ? this.containers.toArray() : []).concat(
            this.contentContainers ? this.contentContainers.toArray() : [],
        );
    }
}
